import BrandProvider from './BrandProvider';

export default BrandProvider;
